import React, { useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import ChallengeCard from '../next_challenge/ChallengeCard';
import AddChallengeCard from './AddChallengeCard';
import { MY_ROOM_ROUTE } from '../../../constants/routes.constants';
import { useHistory } from 'react-router-dom';

const AddNextChallengeList = (props) => {
  // console.log(props,'propss')
  const { repos, handler } = props;
  const [showLayer, setShowLayer] = useState('hide');
  const [count, setCount] = useState(0)
  const history = useHistory();

  const goToMyRoom = () => {
    history.push({
      pathname: MY_ROOM_ROUTE,
      state: {
        from:'add_challenges',
      },
    });
    window.scrollTo(0, 0);
    // window.location.reload();
  };

  if (!repos || repos.length === 0)
    return <div className="no-data">Loading...</div>;

    const handleClick = () => {
      setCount(count + 1)
      // console.log(count)
    }

  return (
    <Container>
      {repos.map((repo, index) => {
        // Have to find best way out for click event handling
        return (
          <Row className="justify-content-md-center mt-4" key={index}>
            <AddChallengeCard challenge={repo} handleClick={handler} count={count} setCount={setCount}/>
          </Row>
        );
      })}
      <Row className="justify-content-md-center floatbtn-margin"></Row>
      <Row className="justify-content-md-center mt-4 pb-3  fix-bottom-btn">
        {count !== 3 ?
        <button className="gred-btn add-btn-interest go-to-room" onClick={goToMyRoom} disabled={count < 3}>SELECT {3 - count} MORE CHALLENGES</button>
        :
        <button className="gred-btn add-btn-interest go-to-room" onClick={goToMyRoom} disabled={count < 3}>GO TO YOUR ROOM!</button>
        }
      </Row>
    </Container>
  );
};

export default AddNextChallengeList;
